import { type IntlShape } from 'react-intl'

import { type ChannelId } from '@onr/schema'

import { type MessageIds } from '@/l10n/types'

const channelKey = (channelId: ChannelId, suffix: 'name' | 'mute' | 'unmute') =>
  `channel.${channelId}.${suffix}` as keyof MessageIds

export const channelName = (intl: IntlShape, channelId: ChannelId) =>
  intl.formatMessage({ id: channelKey(channelId, 'name') })

export const channelMuteLabel = (intl: IntlShape, channelId: ChannelId, muted: boolean) =>
  intl.formatMessage({ id: channelKey(channelId, muted ? 'unmute' : 'mute') })
